import Vue from 'vue'
import VueRouter from 'vue-router'
import ActivityLog from '../views/ActivityLog.vue'
import DownloadTransaction from '../views/DownloadTransaction.vue'
import DownloadTransactionNfc from '../views/DownloadTransactionNfc.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import LoginCallback from '../views/LoginCallback.vue'
import LoginIssue from '../views/LoginIssue.vue'
import Maintenance from '../views/Maintenance.vue'
import NetworkIssue from '../views/NetworkIssue.vue'
import NotFound from '../views/NotFound.vue'
import Profile from '../views/Profile.vue'
import AccessAuthority from '../views/access-authority/AccessAuthority.vue'
import Admin from '../views/admin/Admin.vue'
import AnnouncementList from '../views/announcement-list/AnnouncementList.vue'
import Announcement from '../views/announcement/Announcement.vue'
import Area from '../views/area/Area.vue'
import CardType from '../views/card-type/CardType.vue'
import Card from '../views/card/Card.vue'
import CompanyLeaveRight from '../views/company-leave-right/CompanyLeaveRight.vue'
import CompanyLocation from '../views/company-location/CompanyLocation.vue'
import Company from '../views/company/Company.vue'
import Duty from '../views/duty/Duty.vue'
import DutyMatching from '../views/duty/DutyMatching.vue'
import EmployeeLeaveRight from '../views/employee-leave-right/EmployeeLeaveRight.vue'
import EmployeeLevel from '../views/employee-level/EmployeeLevel.vue'
import EmployeePolicy from '../views/employee-policy/EmployeePolicy.vue'
import Employee from '../views/employee/Employee.vue'
import EmployeeType from '../views/employeeType/EmployeeType.vue'
import EmployeesGroup from '../views/employees-group/EmployeesGroup.vue'
import CompanyFeature from '../views/feature/CompanyFeature.vue'
import EmployeeFeature from '../views/feature/EmployeeFeature.vue'
import FeatureAll from '../views/feature/FeatureAll.vue'
import HardwareDevice3rdParty from '../views/hardware-device-3rd-party/HardwareDevice3rdParty.vue'
import HardwareDevice from '../views/hardware-device/HardwareDevice.vue'
import HardwareStatus from '../views/hardware-status/HardwareStatus.vue'
import Hardware from '../views/hardware/Hardware.vue'
import HardwareConnectionList from '../views/hardware/HardwareConnectionList.vue'
import HardwaresGroup from '../views/hardwares-group/HardwaresGroup.vue'
import Holiday from '../views/holiday/Holiday.vue'
import LeaveApprover from '../views/leave-approver/LeaveApprover.vue'
import LeaveEntitlement from '../views/leave-entitlement/LeaveEntitlement.vue'
import LeaveFile from '../views/leave-file/LeaveFile.vue'
import LeaveType from '../views/leave-type/LeaveType.vue'
import LockUnlock from '../views/lock-unlock/LockUnlock.vue'
import Lock from '../views/lock/Lock.vue'
import MicrosoftEntraId from '../views/microsoft-entra-id/MicrosoftEntraId.vue'
import DeviceUse from '../views/monitoring/DeviceUse.vue'
import OffsiteLocation from '../views/offsite-location/OffsiteLocation.vue'
import Organization from '../views/organization/Organization.vue'
import PasswordPolicy from '../views/password-policy/PasswordPolicy.vue'
import Position from '../views/position/Position.vue'
import Prefix from '../views/prefix/Prefix.vue'
import ReportT101 from '../views/reports/ReportT101.vue'
import ReportT102 from '../views/reports/ReportT102.vue'
import ReportT103 from '../views/reports/ReportT103.vue'
import ReportT104 from '../views/reports/ReportT104.vue'
import ReportT105 from '../views/reports/ReportT105.vue'
import ReportT106 from '../views/reports/ReportT106.vue'
import ReportW101 from '../views/reports/ReportW101.vue'
import RightsGroup from '../views/rights-group/RightsGroup.vue'
import AccessToken from '../views/security/AccessToken.vue'
import AccessTokenAssign from '../views/security/AccessTokenAssign.vue'
import AccessTokenForm from '../views/security/AccessTokenForm.vue'
import AccessTokenList from '../views/security/AccessTokenList.vue'
import LeaveApproval from '../views/settings/LeaveApproval.vue'
import ShiftWorkSummary from '../views/shift-work-summary/ShiftWorkSummary.vue'
import Shift from '../views/shift/Shift.vue'
import TaEmployeesGroup from '../views/ta-employees-group/TaEmployeesGroup.vue'
import TaHardwaresGroup from '../views/ta-hardwares-group/TaHardwaresGroup.vue'
import TaRightsGroup from '../views/ta-rights-group/TaRightsGroup.vue'
import TimeAttendanceOffSite from '../views/time-attendance/TimeAttendanceOffSite.vue'
import Timezone from '../views/timezone/Timezone.vue'
import TwoFactorAuth from '../views/two-factor-auth/TwoFactorAuth.vue'
import Unlock from '../views/unlock/Unlock.vue'
import UploadPayslip from '../views/upload/UploadPayslip.vue'
import UserRole from '../views/user-role/UserRole.vue'
import UserRoleForm from '../views/user-role/UserRoleForm.vue'
import UserRoleList from '../views/user-role/UserRoleList.vue'
import DeveloperEmail from '../views/webhook/DeveloperEmail.vue'
import ResendTransaction from '../views/webhook/ResendTransaction.vue'
import WebhookSubscription from '../views/webhook/WebhookSubscription.vue'
import WorkingHours from '../views/working-hours/WorkingHours.vue'

import { generateCodeChallenge, generateCodeVerifier } from '../utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/announcement-list',
    name: 'AnnouncementList',
    component: AnnouncementList,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: Maintenance,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/login-callback',
    name: 'LoginCallback',
    component: LoginCallback,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/announcement',
    name: 'Announcement',
    component: Announcement,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/company',
    name: 'Company',
    component: Company,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/position',
    component: Position,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/area',
    component: Area,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/prefix',
    component: Prefix,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/employee',
    component: Employee,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/employee-type',
    component: EmployeeType,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/employee-level',
    component: EmployeeLevel,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/shift',
    component: Shift,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/shift-work-summary',
    component: ShiftWorkSummary,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/organization',
    name: 'Organization',
    component: Organization,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/admin',
    component: Admin,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/access-token',
    component: AccessToken,
    // a meta field
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'AccessTokenList',
        component: AccessTokenList,
      },
      {
        path: 'add',
        name: 'AccessTokenAdd',
        component: AccessTokenForm,
      },
      {
        path: ':id/assign',
        name: 'AccessTokenAssign',
        component: AccessTokenAssign,
      },
    ],
  },
  {
    path: '/upload-payslip',
    name: 'UploadPayslip',
    component: UploadPayslip,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/download-transaction',
    name: 'DownloadTransaction',
    component: DownloadTransaction,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/download-transaction-nfc',
    name: 'DownloadTransactionNfc',
    component: DownloadTransactionNfc,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/activity-log',
    name: 'ActivityLog',
    component: ActivityLog,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/time-attendance-off-site',
    name: 'TimeAttendanceOffSite',
    component: TimeAttendanceOffSite,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/duty',
    name: 'Duty',
    component: Duty,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/duty-matching',
    name: 'DutyMatching',
    component: DutyMatching,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/hardware',
    name: 'Hardware',
    component: Hardware,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/hardware-device',
    name: 'HardwareDevice',
    component: HardwareDevice,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/hardware-device-3rd-party',
    name: 'HardwareDevice3rdParty',
    component: HardwareDevice3rdParty,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/lock-unlock',
    name: 'LockUnlock',
    component: LockUnlock,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/hardware-connections',
    name: 'HardwareConnectionList',
    component: HardwareConnectionList,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/card',
    name: 'Card',
    component: Card,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/card-type',
    name: 'CardType',
    component: CardType,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/feature-all',
    name: 'FeatureAll',
    component: FeatureAll,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/company-feature',
    name: 'CompanyFeature',
    component: CompanyFeature,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/employee-feature',
    name: 'EmployeeFeature',
    component: EmployeeFeature,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/leave-approver',
    name: 'LeaveApprover',
    component: LeaveApprover,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/leave-type',
    name: 'LeaveType',
    component: LeaveType,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/leave-file',
    name: 'LeaveFile',
    component: LeaveFile,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/holiday',
    name: 'Holiday',
    component: Holiday,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/timezone',
    name: 'Timezone',
    component: Timezone,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/lock',
    name: 'Lock',
    component: Lock,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/unlock',
    name: 'Unlock',
    component: Unlock,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/ta-rights-group',
    name: 'TaRightsGroup',
    component: TaRightsGroup,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/ta-employees-group',
    name: 'TaEmployeesGroup',
    component: TaEmployeesGroup,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/ta-hardwares-group',
    name: 'TaHardwaresGroup',
    component: TaHardwaresGroup,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/rights-group',
    name: 'RightsGroup',
    component: RightsGroup,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/access-authority',
    name: 'AccessAuthority',
    component: AccessAuthority,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/employees-group',
    name: 'EmployeesGroup',
    component: EmployeesGroup,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/hardwares-group',
    name: 'HardwaresGroup',
    component: HardwaresGroup,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/report-t101',
    name: 'ReportT101',
    component: ReportT101,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/report-t102',
    name: 'ReportT102',
    component: ReportT102,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/report-t103',
    name: 'ReportT103',
    component: ReportT103,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/report-t104',
    name: 'ReportT104',
    component: ReportT104,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/report-t105',
    name: 'ReportT105',
    component: ReportT105,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/report-t106',
    name: 'ReportT106',
    component: ReportT106,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/report-w101',
    name: 'ReportW101',
    component: ReportW101,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/device-use',
    name: 'DeviceUse',
    component: DeviceUse,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/hardware-status',
    name: 'HardwareStatus',
    component: HardwareStatus,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/user-role',
    component: UserRole,
    // a meta field
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'UserRoleList',
        component: UserRoleList,
      },
      {
        path: 'add',
        name: 'UserRoleAdd',
        component: UserRoleForm,
      },
      {
        path: 'edit/:role_uuid',
        name: 'UserRoleEdit',
        component: UserRoleForm,
      },
    ],
  },
  {
    path: '/employee-policy',
    name: 'EmployeePolicy',
    component: EmployeePolicy,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/two-factor-auth',
    name: 'TwoFactorAuth',
    component: TwoFactorAuth,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/microsoft-entra-id',
    name: 'MicrosoftEntraId',
    component: MicrosoftEntraId,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/password-policy',
    name: 'PasswordPolicy',
    component: PasswordPolicy,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/leave-entitlement',
    name: 'LeaveEntitlement',
    component: LeaveEntitlement,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/company-leave-right',
    name: 'CompanyLeaveRight',
    component: CompanyLeaveRight,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/employee-leave-right',
    name: 'EmployeeLeaveRight',
    component: EmployeeLeaveRight,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/leave-approval',
    name: 'LeaveApproval',
    component: LeaveApproval,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/webhook-subscription',
    name: 'WebhookSubscription',
    component: WebhookSubscription,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/webhook-developer',
    name: 'DeveloperEmail',
    component: DeveloperEmail,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/webhook-resend-transaction',
    name: 'ResendTransaction',
    component: ResendTransaction,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/working-hours',
    name: 'WorkingHours',
    component: WorkingHours,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/company-location',
    name: 'CompanyLocation',
    component: CompanyLocation,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/offsite-location',
    name: 'OffsiteLocation',
    component: OffsiteLocation,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '/about',
    name: 'About',
    // a meta field
    meta: { requiresAuth: true },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/network-issue',
    name: 'NetworkIssue',
    component: NetworkIssue,
    props: true,
  },
  {
    path: '/login-issue',
    name: 'LoginIssue',
    component: LoginIssue,
    props: true,
  },
  {
    path: '/404',
    name: '404',
    component: NotFound,
    // a meta field
    meta: { requiresAuth: true },
  },
  {
    path: '*',
    redirect: { name: '404' },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// Navigation Guards
router.beforeEach(async (to, from, next) => {
  const loggedIn = window.localStorage.getItem('user')

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!loggedIn) {
      var code_verifier = generateCodeVerifier()
      var code_challenge = generateCodeChallenge(code_verifier)

      window.localStorage.setItem('code_verifier', code_verifier)
      window.localStorage.setItem('code_challenge', code_challenge)

      const state = 'random-value'
      const code_challenge_method = 'S256'

      const authEndpoint = process.env.VUE_APP_AUTH_ENDPOINT
      const authType = process.env.VUE_APP_AUTH_TYPE
      const authResponseType = process.env.VUE_APP_AUTH_RESPONSE_TYPE
      const authClientID = process.env.VUE_APP_AUTH_CLIENT_ID

      const redirectUri =
        process.env.VUE_APP_MODE === 'development'
          ? 'http://localhost:8080/login-callback' // TODO: when upto could change to process.env.VUE_APP_AUTH_REDIRECT_URI
          : process.env.VUE_APP_AUTH_REDIRECT_URI

      window.location.replace(
        `${authEndpoint}${authType}?response_type=${authResponseType}&client_id=${authClientID}&state=${state}&code_challenge=${code_challenge}&code_challenge_method=${code_challenge_method}&redirect_uri=${redirectUri}`
      )

      // next()
      // next({ name: 'Login' })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()
  }
})

export default router
